import { render } from "./TableSortMenu.vue?vue&type=template&id=247bcd1a"
import script from "./TableSortMenu.vue?vue&type=script&lang=js"
export * from "./TableSortMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__